import { Injectable } from '@angular/core';
import { firstValueFrom, map, Observable } from 'rxjs';
import { PQRFormacaoJornadaRemuneracaoProfessoresDto } from '../../dtos';
import { environment } from '../../../environments/environment';
import { CaqRequestService } from '..'

interface ListPQRFormacaoJornadaRemuneracaoProfessores {
  _embedded: {
    'pqr-formacao-jornada-remuneracao-professores': PQRFormacaoJornadaRemuneracaoProfessoresDto[];
  };
}

@Injectable({
  providedIn: 'root',
})
export class PQRFormacaoJornadaRemuneracaoProfessoresService {
  private apiUrl = `${environment.apiUrl}/pqr-formacao-jornada-remuneracao-professores`;

  constructor(
    private caqRequestService: CaqRequestService
  ) {}

  buscarListaDePQRFormacaoJornadaRemuneracaoProfessores(): Observable<PQRFormacaoJornadaRemuneracaoProfessoresDto[]> {
    return this.caqRequestService
      .get<ListPQRFormacaoJornadaRemuneracaoProfessores>(this.apiUrl)
      .pipe(map((response) => response._embedded?.['pqr-formacao-jornada-remuneracao-professores'] || []));
  }

  salvePQRFormacaoJornadaRemuneracaoProfessores(requisicao: PQRFormacaoJornadaRemuneracaoProfessoresDto){
    return firstValueFrom(this.caqRequestService
      .put<PQRFormacaoJornadaRemuneracaoProfessoresDto>(`${this.apiUrl}/${requisicao.codPqrFormacaoJornadaRemuneracaoProfessores}`, requisicao)
      .pipe(map((response) => response)));
  }
}
